import React from 'react';

const wrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: 'var(--space-10) var(--space-6)',
  gap: 'var(--space-4)',
};

const iconStyle = {
  width: 72,
  height: 72,
  borderRadius: 9999,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'var(--primary-50)',
  color: 'var(--primary-dark)',
  fontSize: 32,
  marginBottom: 'var(--space-2)',
};

const titleStyle = {
  fontFamily: '"Plus Jakarta Sans", "IBM Plex Sans Arabic", Inter, sans-serif',
  fontSize: 'var(--text-xl)',
  fontWeight: 700,
  color: 'var(--text-primary)',
  margin: 0,
  letterSpacing: '-0.01em',
};

const descriptionStyle = {
  color: 'var(--text-secondary)',
  fontSize: 'var(--text-sm)',
  maxWidth: '32ch',
  lineHeight: 1.55,
  margin: 0,
};

/**
 * Calm, resolvable empty state surface. Used for empty cart, empty KDS,
 * "no items yet" admin Menu, etc. Pass either an `illustration` node or an
 * `icon` (emoji or React node). Avoid accusatory tone in copy.
 */
const EmptyState = ({
  icon,
  illustration,
  title,
  description,
  action,
  className,
  style,
}) => (
  <div className={className} style={{ ...wrapperStyle, ...style }} role="status" aria-live="polite">
    {illustration ? (
      <div style={{ marginBottom: 'var(--space-2)' }}>{illustration}</div>
    ) : icon ? (
      <div style={iconStyle} aria-hidden="true">
        {icon}
      </div>
    ) : null}
    {title && <h3 style={titleStyle}>{title}</h3>}
    {description && <p style={descriptionStyle}>{description}</p>}
    {action && <div style={{ marginTop: 'var(--space-2)' }}>{action}</div>}
  </div>
);

export default EmptyState;
